import type { FilterField } from '@vnetwork/ui/data';

/**
 * FilterBuilder field definitions for the Operations services list.
 * Passed to FilterBuilder via Popover — use `defaultValue` NOT `value` (see
 * ui-conventions: controlled `value` breaks the "Add filter" button).
 */
export const opsFilterFields: FilterField[] = [
  {
    value: 'category',
    label: 'Category',
    input: 'select',
    options: [
      { value: 'cdn', label: 'CDN' },
      { value: 'waap', label: 'WAAP' },
      { value: 'storage', label: 'Storage' },
      { value: 'media', label: 'Media' },
      { value: 'compute', label: 'Compute' },
      { value: 'registrar', label: 'Registrar' },
      { value: 'other', label: 'Other' },
    ],
  },
  {
    value: 'provider',
    label: 'Provider',
    input: 'text',
  },
  {
    value: 'status',
    label: 'Status',
    input: 'select',
    options: [
      { value: 'active', label: 'Active' },
      { value: 'pending', label: 'Pending' },
      { value: 'terminated', label: 'Terminated' },
      { value: 'suspended', label: 'Suspended' },
      { value: 'error', label: 'Error' },
    ],
  },
  {
    value: 'org_id',
    label: 'Org ID',
    input: 'text',
  },
];
